import React, { useState, useRef } from 'react';

const SessionList = ({ sessions, onSelect, onDelete }) => {
  const [swipedSessionId, setSwipedSessionId] = useState(null);
  const [touchStart, setTouchStart] = useState(null);
  const [touchStartY, setTouchStartY] = useState(null);
  const swipeRef = useRef(null);
  const isMobile = window.innerWidth <= 640;

  // 处理触摸开始
  const handleTouchStart = (e, sessionId) => {
    if (!isMobile) return;
    setTouchStart(e.targetTouches[0].clientX);
    setTouchStartY(e.targetTouches[0].clientY);
    swipeRef.current = {
      startX: e.targetTouches[0].clientX,
      currentX: e.targetTouches[0].clientX,
      sessionId
    };
  };

  // 处理触摸移动
  const handleTouchMove = (e, sessionId) => {
    if (!isMobile || !touchStart || !swipeRef.current) return;
    
    const currentTouch = e.targetTouches[0].clientX;
    const currentTouchY = e.targetTouches[0].clientY;
    const diffX = touchStart - currentTouch;
    const diffY = Math.abs(touchStartY - currentTouchY);

    swipeRef.current.currentX = currentTouch;

    // 如果Y轴移动距离大于X轴，说明是在滚动
    if (diffY > Math.abs(diffX)) return;

    // 阻止滚动
    if (Math.abs(diffX) > 10) {
      e.preventDefault();
    }

    // 只处理当前滑动的卡片
    if (sessionId === swipeRef.current.sessionId) {
      // 左滑超过50px显示删除按钮
      if (diffX > 50 && diffY < 30) {
        setSwipedSessionId(sessionId);
      }
      // 右滑超过20px隐藏删除按钮
      else if (diffX < -20 && swipedSessionId === sessionId && diffY < 30) {
        setSwipedSessionId(null);
      }
    }
  };

  // 处理触摸结束
  const handleTouchEnd = (e, sessionId) => {
    if (!swipeRef.current || swipeRef.current.sessionId !== sessionId) return;

    const swipeDistance = swipeRef.current.startX - swipeRef.current.currentX;
    
    // 如果滑动距离小于30px，恢复原状
    if (Math.abs(swipeDistance) < 30) {
      setSwipedSessionId(null);
    }
    // 如果是向右滑动（负值），且当前项是展开状态，则收起
    else if (swipeDistance < 0 && swipedSessionId === sessionId) {
      setSwipedSessionId(null);
    }

    setTouchStart(null);
    setTouchStartY(null);
    swipeRef.current = null;
  };

  // 处理点击事件
  const handleClick = (e, sessionId) => {
    // 如果是滑动状态的点击，只处理收起操作
    if (swipedSessionId === sessionId) {
      setSwipedSessionId(null);
      return;
    }
    
    // 如果没有滑动状态，才触发选择
    if (!swipedSessionId) {
      onSelect(sessionId);
    }
  };

  // 修改删除按钮点击处理函数
  const handleDelete = (e, sessionId) => {
    e.preventDefault();  // 阻止默认事件
    e.stopPropagation();  // 阻止事件冒泡
    onDelete(sessionId);  // 直接调用删除函数，因为确认对话框已经在父组件中处理
    setSwipedSessionId(null);  // 重置滑动状态
  };

  return (
    <div className="session-list" onClick={(e) => e.stopPropagation()}>
      {sessions.length === 0 ? (
        <div className="empty-sessions">
          <div className="empty-sessions-icon">📝</div>
          <div className="empty-sessions-text">暂无历史会话</div>
        </div>
      ) : (
        sessions.map((session) => (
          <div 
            key={session.id} 
            className={`session-item ${swipedSessionId === session.id ? 'swiped' : ''}`}
            onTouchStart={(e) => handleTouchStart(e, session.id)}
            onTouchMove={(e) => handleTouchMove(e, session.id)}
            onTouchEnd={(e) => handleTouchEnd(e, session.id)}
            onClick={(e) => handleClick(e, session.id)}
          >
            <div className="session-content">
              {!isMobile && <div className="session-icon">⏱️</div>}
              <div className="session-info">
                <div className="session-title">{session.title}</div>
                <div className="session-time">{session.time}</div>
              </div>
              {!isMobile && (
                <button 
                  className="session-delete"
                  onClick={(e) => handleDelete(e, session.id)}
                  title="删除会话"
                >
                  🗑️
                </button>
              )}
            </div>
            {isMobile && (
              <button 
                className="delete-button"
                onClick={(e) => handleDelete(e, session.id)}
                onTouchEnd={(e) => {
                  e.stopPropagation();  // 阻止触摸事件冒泡
                }}
              >
                删除
              </button>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default SessionList; 